import { useAi } from "src/context/AiContext";
import { useRef, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import MyDivider2 from "src/components/layout/MyDivider2";

export default function AiLayout_Responses() {
  const { response } = useAi();
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [response]);

  if (!response || response.length === 0) return null;

  return (
    <div
      ref={containerRef}
      style={{ maxHeight: "60vh", overflowY: "auto", width: "100%", padding: 12, fontSize: 14 }}>
      {response.map((r, i) => (
        <>
          <ReactMarkdown key={i}>{r}</ReactMarkdown>
          <MyDivider2 />
        </>
      ))}
    </div>
  );
}
